<template>
    <b-modal id="show-practice-steps-modal" hide-footer hide-header-close hide-header>
      <h1 class="page-title link mb-4">{{ $t('show.practice.steps.modal.title') }}</h1>
      <div v-for="(practiceStep) in practiceSteps" :key="practiceStep.id">
        <div class="d-flex flex-column mb-4">
          <div class="bold-text"> {{$t('Audit.practice.step.comment') + practiceStep.indexPracticeStep + ' - ' + practiceStep.title + '  :' }}</div>
          <div> {{ getValue(practiceStep.comment) }}</div>
        </div>
      </div>
    </b-modal>
</template>

<script>

export default {

  name: 'ShowPracticeStepsModal',

  data () {
    return {
      askConfirm: false,
      practiceSteps: []
    }
  },

  methods: {
    getValue (value) {
      if (value === null || value === 'null' || value === '') {
        return 'N/A'
      } else {
        return value.toString()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/audit/ShowPracticeStepsModal.vue